import { liveQuerySubscribeLock, LIVE_QUERY_SUBSCRIBE_LOCK_KEY } from 'util/asyncLocks';
import { getSimplrAccountIdOfSelectedTicket, getPartnersAllowlist } from 'extractFromState';
import * as SimplrUserAuthorization from '@asurion-core/typescript-utils/SimplrUserAuthorization';
import {
  setTagsConfig,
  setPartnerInfo,
  setDecisionTree,
  updateSimplrCategories,
  setFlowDebugStateFavoriteFieldsList,
} from 'actions';
import isEmpty from 'lodash/isEmpty';
import { loadMacrosAndDecisionTreeForAccount } from 'actions/searchActions';
import subscribeToLiveQuery from '../subscribeToLiveQuery';
import { BUSINESS_DETAIL_UPDATE_SUBSCRIPTION } from './businessDetailSubscriptions.gql';
import { TRIAL, ACTIVE } from 'constants/accountStatuses';

let businessDetailSubscription;

const startBusinessDetailLiveQuery = (store) => {
  if (!businessDetailSubscription) {
    liveQuerySubscribeLock.acquire(LIVE_QUERY_SUBSCRIBE_LOCK_KEY, async (lockDoneFunction) => {
      const handleOnUpdateBusinessDetail = (businessDetailObj) => {
        const simplrCategories = businessDetailObj.simplrCategories;
        const simplrAccountId = businessDetailObj.simplrAccountId;
        const decisionTree = businessDetailObj.decisionTree;
        const partnerInfo = businessDetailObj.partnerInfo;
        const tagsConfig = businessDetailObj.tagsConfig;
        const flowDebugStateFavoriteFieldsList = businessDetailObj.flowDebugStateFavoriteFieldsList;
        const state = store.getState();
        const simplrAccountIdOfSelectedTicket = getSimplrAccountIdOfSelectedTicket(state);
        if (!isEmpty(tagsConfig)) {
          store.dispatch(setTagsConfig(tagsConfig, simplrAccountId));
        }
        store.dispatch(setPartnerInfo(partnerInfo, simplrAccountId));
        store.dispatch(setDecisionTree(decisionTree, simplrAccountId));
        store.dispatch(updateSimplrCategories(simplrCategories, simplrAccountId));
        store.dispatch(setFlowDebugStateFavoriteFieldsList(flowDebugStateFavoriteFieldsList, simplrAccountId));
        if (simplrAccountIdOfSelectedTicket === simplrAccountId) {
          store.dispatch(loadMacrosAndDecisionTreeForAccount());
        }
      };

      const state = store.getState();
      const partnersAllowlist = getPartnersAllowlist(
        state,
        SimplrUserAuthorization.POLICY_RESOURCES.BUSINESS_DETAIL_MODEL_READ
      );

      const filter = {
        accountStatus: {
          in: [ACTIVE, TRIAL],
        },
      };

      if (!isEmpty(partnersAllowlist)) {
        filter.and = [{ simplrAccountId: { in: [...partnersAllowlist] } }];
      }

      const variables = {
        filter,
      };
      businessDetailSubscription = subscribeToLiveQuery(
        BUSINESS_DETAIL_UPDATE_SUBSCRIPTION,
        variables,
        'onUpdateBusinessDetail',
        handleOnUpdateBusinessDetail
      );

      lockDoneFunction();
    });
  }
};

export { startBusinessDetailLiveQuery };
